import { store } from "@betacrew/jars-flux";
import { componentKey, setLoadingState, setStateList, setSelectedState, setFormList, setSelectedForm, setTaxYearList, setSelectedTaxYear, setPayerList, setSelectedPayer, setStatePayrollResubmitGridData, setPaginationState, setReloadResubmitGridData, setSelectedStatePayrollResubmitGridData, setUrlFormIdParam, setUrlTaxYearParam, setUrlPayerIdParam } from "./StatePayrollResubmitSlice";
import { all, put, takeLatest } from "redux-saga/effects";
import ResubmitDataService from "../../../../../services/ResubmitDataService";
import SubmitFormsDataService from "../../../../../services/SubmitFormsDataService";
import General from "../../../../../libs/utility/General";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import { IRS_STATE_RESUBMIT_LOADING_STATES } from "../constant";

export const { getStateResubmitStates, getStateResubmitForms, getStateResubmitPayers, getStatePayrollResubmitGridData, reSubmitSelectedFormsToStatePayroll, statePayrollResubmitViewPDF } = {

    getStateResubmitStates: (payload) => {
        return {
            type: "STATE_PAYROLL_RESUBMIT/GET_STATES",
            payload
        }
    },

    getStateResubmitForms: (payload) => {
        return {
            type: "STATE_PAYROLL_RESUBMIT/GET_FORMS",
            payload
        }
    },

    getStateResubmitPayers: (payload) => {
        return {
            type: "STATE_PAYROLL_RESUBMIT/GET_PAYERS",
            payload
        }
    },

    getStatePayrollResubmitGridData: (payload) => {
        return {
            type: "STATE_PAYROLL_RESUBMIT/GET_GRID_DATA",
            payload
        }
    },

    reSubmitSelectedFormsToStatePayroll: (payload) => {
        return {
            type: "STATE_PAYROLL_RESUBMIT/RESUBMIT_SELECTED_FORMS_TO_STATE",
            payload
        }
    },

    statePayrollResubmitViewPDF: (payload) => {
        return {
            type: "STATE_PAYROLL_RESUBMIT/GET_PDF",
            payload
        }
    },
}

function* getStateResubmitStatesAsync(action) {
    try {
        yield put(setLoadingState({ state: IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_STATES_LIST_LOADING, message: "Fetching Data" }));

        const { urlStateParam, urlTaxYearParam = null } = action.payload;
        const response = yield ResubmitDataService.getStatePayrollStateNames()

        const { Message, Status, Data } = response?.data;

        if (Status === 1) {
            if (Data?.StateNames && Data?.TaxYears) {
                const stateList = [...Data.StateNames];
                const taxYearsList = [...Data.TaxYears];
                General.addOptionAndValueKeys(stateList, "StateName", "StateName");
                General.addOptionAndValueKeys(taxYearsList, "TaxYear", "TaxYear");
                yield all([
                    put(setStateList(stateList)),
                    put(setTaxYearList(taxYearsList))
                ]);
                if (urlStateParam) {
                    const findSelectedStateRecord = stateList.find(state => state?.value === urlStateParam)

                    if (findSelectedStateRecord) {
                        yield put(setSelectedState(findSelectedStateRecord))
                    }
                }
                if (urlTaxYearParam) {
                    const findSelectedTaxYearRecord = taxYearsList.find(taxYear => taxYear?.value === urlTaxYearParam)

                    if (findSelectedTaxYearRecord) {
                        yield put(setSelectedTaxYear(findSelectedTaxYearRecord))
                    }
                }
            } else {
                yield put(addNotifications({ heading: "Error", message: "Please try again" }));
            }
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setLoadingState({ state: IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_STATES_LIST_READY }))
    }
}

function* getStateResubmitFormsAsync(action) {
    try {
        yield put(setLoadingState({ state: IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_FORMS_LIST_LOADING, message: "Fetching Data" }));

        const params = action.payload.stateNames;
        const { urlFormIdParam = null } = action.payload;
        const response = yield ResubmitDataService.getStatePayrollFormNames(params)

        const { Message, Status, Data } = response?.data;

        if (Status === 1) {
            if (Data.length > 0) {
                General.addOptionAndValueKeys(Data, "FormName1", "FormId")
                yield put(setFormList(Data))
                if (urlFormIdParam) {
                    const findSelectedFormRecord = Data.find(item => item?.value == urlFormIdParam)
                    if (findSelectedFormRecord) {
                        yield put(setSelectedForm(findSelectedFormRecord))
                    }
                    yield put(setUrlFormIdParam(null));
                }
            } else {
                yield put(addNotifications({ heading: "Error", message: "Forms not found" }));
            }
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setLoadingState({ state: IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_FORMS_LIST_READY }))
    }
}

function* getStateResubmitPayersAsync(action) {
    try {
        yield put(setLoadingState({ state: IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_PAYERS_LIST_LOADING }))

        const { urlPayerIdParam = null } = action.payload;
        const params = action.payload.formId;
        const response = yield ResubmitDataService.getStatePayrollPayerNames(params)
        const { Message, Status, Data } = response?.data;

        if (Status === 1) {
            if (Data.length > 0) {
                General.addOptionAndValueKeys(Data, "PayerName", "PayerDetailId")
                yield put(setPayerList(Data))
                if (urlPayerIdParam) {
                    const findSelectedPayerRecord = Data.find(item => item?.value == urlPayerIdParam)
                    if (findSelectedPayerRecord) {
                        yield put(setSelectedPayer(findSelectedPayerRecord))
                        yield put(setReloadResubmitGridData(true));
                    }
                    yield put(setUrlPayerIdParam(null));
                }
            } else {
                yield put(addNotifications({ heading: "Error", message: "Payers not found" }));
            }
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setLoadingState({ state: IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_PAYERS_LIST_READY }))
    }
}

function* getStatePayrollResubmitGridDataAsync(action) {
    try {
        yield put(setLoadingState({ state: IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_GRID_RECORDS_LOADING }))

        const { payer, taxYear, formId } = action.payload

        const params = {
            payer,
            taxYear,
            formId,
        }
        const response = yield ResubmitDataService.getStatePayrollResubmitGridData(params);

        const { Message, Status } = response?.data;

        const Data = General.extractDataFromResponseData(response?.data)

        if (Status === 1) {
            if (Data) {
                if (Data.length > 0) {
                    yield put(setStatePayrollResubmitGridData(Data))
                    yield put(setPaginationState({ total: General.extractPaginationTotalFromResponse(response.data) }))
                } else {
                    yield put(setStatePayrollResubmitGridData([]));
                    yield put(setSelectedStatePayrollResubmitGridData([]));
                }
            } else {
                yield put(addNotifications({ heading: "Error", message: "Please try again" }));
            }
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }
        yield put(setReloadResubmitGridData(false));

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setLoadingState({ state: IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_GRID_RECORDS_READY }))
    }
}

function* reSubmitSelectedFormsToStatePayrollAsync(action) {
    try {
        yield put(setLoadingState({ state: IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_GRID_RECORDS_LOADING }))

        const { data } = action.payload;
        const response = yield ResubmitDataService.resubmitToStatePayroll(data)

        const { Message, Status } = response?.data;

        if (Status === 1) {
            yield put(setReloadResubmitGridData(true));
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setLoadingState({ state: IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_GRID_RECORDS_READY }))
    }
}

function* statePayrollResubmitViewPDFAsync(action) {
    try {
        const { formId, payerId, formTypeId, payerName } = action.payload
        yield put(setLoadingState({ state: `${IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_VIEW_PDF_LIST_LOADING}-${formId}` }));

        const data = {
            formId,
            payerId: payerId,
            formTypeId: formTypeId,
            PayerName: payerName,
            isUnMask: false,
            employerId: 0
        }

        const response = yield SubmitFormsDataService.viewStatePayrollPDF(data);
        const { Status, Data } = response?.data;
        if (Status === 1 && Data) {
            General.openBase64FileInNewTab(Data?.Base64, Data?.Name)
        } else {
            yield put(addNotifications({ heading: "Failed to open the PDF", message: "Please try again" }));
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setLoadingState({ state: IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_VIEW_PDF_LIST_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getStateResubmitStates().type, getStateResubmitStatesAsync),
        takeLatest(getStateResubmitForms().type, getStateResubmitFormsAsync),
        takeLatest(getStateResubmitPayers().type, getStateResubmitPayersAsync),
        takeLatest(getStatePayrollResubmitGridData().type, getStatePayrollResubmitGridDataAsync),
        takeLatest(reSubmitSelectedFormsToStatePayroll().type, reSubmitSelectedFormsToStatePayrollAsync),
        takeLatest(statePayrollResubmitViewPDF().type, statePayrollResubmitViewPDFAsync)
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);